<template>
    <v-select :value="sort" :items="sortMethods" @input="(sort) => $router.push({ query: { ...this.$route.query, sort, page: 1 } })" outlined hide-details class="w-100 mw-md-200px" />
</template>

<script>
const sortMethods = [
    { text: "최신등록순", value: "created_at_desc" },
    { text: "높은추정가", value: "price_estimated_desc" },
    { text: "낮은추정가", value: "price_estimated_asc" },
    { text: "높은시작가", value: "price_auction_from_desc" },
    { text: "낮은시작가", value: "price_auction_from_asc" },
    { text: "높은현재가", value: "price_auction_current_desc" },
    { text: "낮은현재가", value: "price_auction_current_asc" },
    { text: "많은응찰", value: "bids_length_desc" },
    { text: "적은응찰", value: "bids_length_asc" },
];
export default {
    data() {
        return {
            sortMethods,
        };
    },
    computed: {
        sort() {
            return this.$route.query.sort || "created_at_desc";
        },
    },
};
</script>
